import { toast } from 'react-toastify'

interface ToastProps {
  message: string;
}

export const showSuccessToast = ({ message }: ToastProps) => {
  return toast.success(message, {
    position: toast.POSITION.TOP_CENTER,
    className: 'bg-white',
    style: {
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e0e0',
      color: 'black',
    },
    progressStyle: {
      background: '#0E9F6E',
    },
    icon: () => (
      <svg
        width='26'
        height='26'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={{color: '#0E9F6E'}}
      >
        <path
          d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z'
          fill='currentColor'
        />
      </svg>
    ),
    autoClose: 3000,
  })
}

export const showErrorToast = ({ message }: ToastProps) => {
  return toast.error(message, {
    position: toast.POSITION.TOP_CENTER,
          className: "bg-white",
          style: {
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            color: "black",
          },
          autoClose: 3000,
  })
}

export const showLoadingToast = ({ message }: ToastProps) => {
  return toast.loading(message, {
    position: toast.POSITION.TOP_CENTER,
    className: 'bg-white',
    style: {
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e0e0e0',
      color: 'black',
    },
    progressStyle: {
      background: '#5A5A5A',
    }
  })
}

export const updateLoadingToast = (toastId: string | number, { message, type = 'info', isLoading = true }: { message: string; type?: 'info' | 'success' | 'error'; isLoading?: boolean }) => {
    toast.update(toastId, {
      render: message,
      type: type,
      isLoading: isLoading,
      position: toast.POSITION.TOP_CENTER,
      className: 'bg-white',
      style: {
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
        color: 'black',
      },
      progressStyle: {
        background: type === 'success' ? '#0E9F6E' : type === 'error' ? '#EE3043' : '#5A5A5A',
      },
      autoClose: !isLoading ? 3000 : false,
    })
  }

  export const dismissLoadingToast = (toastId: string | number) => {
    toast.dismiss(toastId);
  }

export const showInfoToast = ({ message }: ToastProps) => {
    return toast.info(message, {
      position: toast.POSITION.TOP_CENTER,
      className: 'bg-white',
      style: {
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e0e0e0',
        color: 'black',
      },
      progressStyle: {
        background: '#5A5A5A',
      },
      icon: () => (
        <svg
          width='26'
          height='26'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{color: '#5A5A5A'}}
        >
          <path
            d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z'
            fill='currentColor'
          />
        </svg>
      ),
      autoClose: 3000,
    })
  }
  
  // ... existing code ...